import React from "react";
import "./Button.scss";

export default function Button({
  text,
  className,
  href,
  newTab = false,
  download,
  rel
}) {
  const downloadAttr =
    typeof download === "string" ? download : download ? "" : undefined;

  // IMPORTANT:
  // ESLint rule react/jsx-no-target-blank may not reliably analyze computed rel values.
  // Use a literal rel string whenever target="_blank" is present.
  if (newTab) {
    return (
      <div className={className}>
        <a
          className="main-button"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={downloadAttr}
        >
          {text}
        </a>
      </div>
    );
  }

  return (
    <div className={className}>
      <a
        className="main-button"
        href={href}
        rel={rel}
        download={downloadAttr}
      >
        {text}
      </a>
    </div>
  );
}
